app.service("SiteShared", ['$rootScope', 'SiteHelper', 'ModelConstructor', 'RequestService', 'NavigationManager', 'TemplateConfig', function ($rootScope, SiteHelper, ModelConstructor, RequestService, NavigationManager, TemplateConfig) {

    $rootScope.site_shared = this;
    $rootScope.site_helper = SiteHelper;
    $rootScope.model_constructor = ModelConstructor;
    $rootScope.navigation_manager = NavigationManager;
    $rootScope.navigation_model = $rootScope.navigation_manager.model;
    $rootScope.template_config = TemplateConfig;

    $rootScope.factory = {};
    $rootScope.model = {};

    $rootScope.service = {
        request: RequestService,
    };

    this.addServices = function (toAddServices) {
        for (let key in toAddServices) {
            $rootScope.service[key] = toAddServices[key];
        }
    }

    const sharedClasses = [$rootScope.site_shared, $rootScope.site_helper, $rootScope.model_constructor, $rootScope.navigation_manager];

    this.populateModelsAndFactories = function () {
        for (let serviceID in $rootScope.service) {
            const service = $rootScope.service[serviceID];

            if (service.model) {
                if (!$rootScope.model[serviceID]) {
                    $rootScope.model[serviceID] = service.model;
                }
            }

            if (service.factory) {
                if (!$rootScope.factory[serviceID]) {
                    $rootScope.factory[serviceID] = service.factory;
                }
            }
            sharedClasses.push(service)

        }
    }

    this.triggerMasterInit = function () {
        for (let i = 0; i < sharedClasses.length; i++) {
            const sharedClass = sharedClasses[i];
            if (sharedClass.masterInit) {
                sharedClass.masterInit();
            }
        }
        for (let i = 0; i < sharedClasses.length; i++) {
            const sharedClass = sharedClasses[i];
            if (sharedClass.applyPageVars) {
                sharedClass.applyPageVars();
            }
        }
    }

    this.triggerIndexInit = function () {
        for (let i = 0; i < sharedClasses.length; i++) {
            const sharedClass = sharedClasses[i];
            if (sharedClass.indexInit) {
                sharedClass.indexInit();
            }
        }
    }

}]);